
import React from 'react';
import { Target, Plus, Search } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { EmptyStateLayout } from './EmptyStateLayout';

interface LeadsEmptyStateProps {
  onAddLead?: () => void;
  onSearchJobs?: () => void;
}

export const LeadsEmptyState: React.FC<LeadsEmptyStateProps> = ({ onAddLead, onSearchJobs }) => {
  return (
    <EmptyStateLayout
      icon={Target}
      title="No Business Leads Yet"
      description="Start building your sales pipeline by finding potential job opportunities."
    >
      <div className="flex flex-col sm:flex-row gap-3 justify-center mt-4">
        <Button onClick={onSearchJobs}>
          <Search className="h-4 w-4 mr-2" />
          Search Job Opportunities
        </Button>
        <Button variant="outline" onClick={onAddLead}>
          <Plus className="h-4 w-4 mr-2" />
          Add Lead Manually
        </Button>
      </div>
      <div className="mt-6 text-sm text-muted-foreground">
        <p className="mb-2">Business development tools:</p>
        <ul className="text-left max-w-md mx-auto space-y-1">
          <li>• Search job boards for opportunities</li>
          <li>• Track leads through your sales pipeline</li>
          <li>• Convert leads to active clients</li>
        </ul>
      </div>
    </EmptyStateLayout>
  );
};
